module.exports = __webpack_public_path__ + "assets/desktop.3b6face9.svg";